<div class="dialog-panel dialog-post">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  @if (activePost) {
    <div class="dialog-content">
      @if (loading) {
        <div class="spinner-container p-absolute">
          <mat-spinner class="primary" [diameter]="30"></mat-spinner>
        </div>
      }
      <div class="dialog-header">
        @switch (activePost.status) {
          @case (ShopPostStatus.AwaitsCustomer) {
            <h1 class="dialog-title dot">
              {{ 'planning.edit_post' | transloco }}
            </h1>
          }
          @case (ShopPostStatus.Planned) {
            <h1 class="dialog-title dot">{{ 'planning.edit_post' | transloco }}</h1>
          }
          @case (ShopPostStatus.ToBePosted) {
            <h1 class="dialog-title dot">
              {{ 'planning.planned_post' | transloco }}
            </h1>
          }
          @default {
            <h1 class="dialog-title dot">{{ 'planning.planning_post' | transloco }}</h1>
          }
        }
      </div>
      @if (activePost.post_draft_id) {
        <div>
          <div class="draft-images-container">
            @if (activePost.photo_facebook_feed) {
              <div class="image-box" [lazyLoad]="activePost.photo_facebook_feed.url1x">
                <div class="social-img-icon" [lazyLoad]="'/assets/social/facebook.png'"></div>
              </div>
            }
            @if (activePost.photo_facebook_story) {
              <div class="image-box" [lazyLoad]="activePost.photo_facebook_story.url1x">
                <div class="social-img-icon" [lazyLoad]="'/assets/social/facebook.png'"></div>
              </div>
            }
            @if (activePost.photo_instagram_feed) {
              <div class="image-box" [lazyLoad]="activePost.photo_instagram_feed.url1x">
                <div class="social-img-icon" [lazyLoad]="'/assets/social/instagram.png'"></div>
              </div>
            }
            @if (activePost.photo_instagram_reels) {
              <div class="image-box" [lazyLoad]="activePost.photo_instagram_reels.url1x">
                <div class="social-img-icon" [lazyLoad]="'/assets/social/instagram.png'"></div>
              </div>
            }
            @if (activePost.photo_instagram_story) {
              <div class="image-box" [lazyLoad]="activePost.photo_instagram_story.url1x">
                <div class="social-img-icon" [lazyLoad]="'/assets/social/instagram.png'"></div>
              </div>
            }
            @if (activePost.photo_tik_tok_feed) {
              <div class="image-box" [lazyLoad]="activePost.photo_tik_tok_feed.url1x">
                <div class="social-img-icon" [lazyLoad]="'/assets/social/tiktok.png'"></div>
              </div>
            }
          </div>
        </div>
      }
      <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="formPost" (submit)="onSubmit()">
        <div class="dialog-body selected-post pt-0">
          <div class="row flex-nowrap post-type mb-2">
            <div class="col-12 align-self-center">
              <div class="socials">
                @if (activePost.platforms) {
                  <div>
                    @for (platform of activePost.platforms?.split('|'); track platform) {
                      <img class="social-img" [lazyLoad]="'/assets/social/' + platform.toLowerCase() + '.png'" />
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-field-container pl-0">
              @if (postDoesntHaveStatus || isEditorVisible) {
                <lib-drag-drop-photos
                  [maxFileSize]="5"
                  [alternativeLook]="true"
                  [staticImage]="activePost?.photo || null"
                  [editorImage]="!isPostPhotoFromEditor && activePost.editor_photo"
                  [items]="
                    formPost.get('media').value && activePost.photos_customer_required
                      ? formPost.get('media').value
                      : []
                  "
                  (filesChange)="updateImages($event)"
                  (filesChange)="updateImages($event)"
                  [photoEditorEnabled]="activePost.editor"
                >
                  @if (activePost.editor) {
                    <div class="photo-editor-btn-container">
                      <button type="button" class="photo-editor-btn" (click)="openPhotoEditor()">
                        <div class="edit-post-icon" [inlineSVG]="'/icons/icon-edit-post.svg'"></div>
                        <div class="mt-2">{{ 'photo_editor.edit_photo' | transloco }}</div>
                      </button>
                    </div>
                  }
                </lib-drag-drop-photos>
              } @else {
                <div class="static-photo" [lazyLoad]="activePost.photo?.url1x"></div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-8 form-field-container">
              <div class="form-field-label">
                {{ 'form.field.post_title' | transloco }}
              </div>
              <mat-form-field class="form-field readonly" [floatLabel]="'auto'">
                <input matInput [formControlName]="'title'" readonly />
              </mat-form-field>
            </div>
            <div class="form-field-container col-12 col-sm-8 col-lg-4">
              <div class="form-field-label">
                {{ 'form.field.start_date' | transloco }}
              </div>
              <lib-date-time-field
                [class.readonly]="activePost.status > 0"
                [class.error-margin]="
                  formPost.get('planned').errors?.dateTimeMin || formPost.get('planned').errors?.required
                "
                [formControlName]="'planned'"
                [min]="minDate"
                [readonly]="activePost.status > 0"
              >
                @if (formPost.get('planned').invalid) {
                  <mat-error>
                    @if (formPost.get('planned').errors.required) {
                      {{ 'form.error.required' | transloco }}
                    }
                  </mat-error>
                }
                @if (formPost.get('planned').errors?.dateTimeMin ? true : false) {
                  <div class="mat-error">
                    {{ 'form.error.min_date_24_from_now' | transloco }}
                  </div>
                }
              </lib-date-time-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-field-container">
              <div class="form-field-label">
                {{ 'form.field.description' | transloco }}
              </div>
              <mat-form-field class="form-field" [class.readonly]="activePost.status > 0" [floatLabel]="'auto'">
                <textarea
                  matInput
                  [formControlName]="'body'"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="10"
                  [readonly]="activePost.status > 0"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-field-container">
              <div class="form-field-label">
                {{ 'form.field.hashtags' | transloco }}
              </div>
              <mat-form-field class="form-field" [floatLabel]="'auto'" [class.readonly]="activePost.status > 0">
                <mat-chip-grid #tagsList [disabled]="activePost.status > 0">
                  @for (tag of hashtags; track tag) {
                    <mat-chip-row [removable]="true" (removed)="removeTag(tag)">
                      {{ tag }}
                      <span matChipRemove class="icon-remove" [inlineSVG]="'/icons/icon-close.svg'"></span>
                    </mat-chip-row>
                  }
                  <input
                    [matChipInputFor]="tagsList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="false"
                    (matChipInputTokenEnd)="addTag($event)"
                  />
                </mat-chip-grid>
              </mat-form-field>
            </div>
          </div>
          @if (nextPostTemplatedId || prevPostTemplatedId) {
            <div class="arrows-container">
              <div class="row">
                <div class="col-12 col-md-6 text-center text-md-left mb-4 mb-md-0">
                  @if (prevPostTemplatedId) {
                    <button type="button" class="btn btn-arrow btn-prev" (click)="onSubmit(prevPostTemplatedId)">
                      <span class="icon" [inlineSVG]="'/icons/icon-prev-2.svg'"></span>
                      {{ 'planning.previous_post' | transloco }}
                    </button>
                  }
                </div>
                <div class="col-12 col-md-6 text-center text-md-right">
                  @if (nextPostTemplatedId) {
                    <button type="button" class="btn btn-arrow btn-next" (click)="onSubmit(nextPostTemplatedId)">
                      {{ 'planning.next_post' | transloco }}
                      <span class="icon" [inlineSVG]="'/icons/icon-next-2.svg'"></span>
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (!(activePost.status > 0)) {
          <div class="dialog-bottom">
            <div class="row">
              <div class="ml-auto col-12 col-md-4">
                <button type="submit" class="btn btn-primary d-block w-100" [disabled]="formPost.invalid">
                  @if (!activePost.id) {
                    {{ 'global.confirm' | transloco }}
                  } @else {
                    {{ (editorPhotoSaveClicked ? 'global.publish' : 'global.update') | transloco }}
                  }
                </button>
              </div>
            </div>
          </div>
        }
      </form>
    </div>
  }
</div>
